import React from 'react';
import MasterCrud from './MasterCrud';

export default function Carriers() {
  return (
    <MasterCrud
      title="Carriers"
      endpoint="/api/master/carriers"
      columns={[
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name' },
        { key: 'plantId', label: 'Plant ID' },
        { key: 'surchargePct', label: 'Surcharge %' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'code', label: 'Code', required: true },
        { key: 'name', label: 'Name', required: true },
        { key: 'plantId', label: 'Plant ID' },
        { key: 'surchargePct', label: 'Surcharge %', type: 'number' },
      ]}
    />
  );
}
